/*
添加者 魏强(2018.2.25)
*/
<template>
<div>
	<ul class="store-list">
		<li class="item" v-for="(store,index) in data">
			<dl class="shop-info">
				<dt class="shop-name">
					<router-link :to="{path:'/shop',query:{store_id:store.storeId,tab:1}}" target="_blank">
						{{store.storeName}}
					</router-link>
				</dt>
				<dd class="shop-pic">
					<router-link :to="{path:'/shop',query:{store_id:store.storeId,tab:1}}" target="_blank">
						<span class="size72">
							<img  class="size72" border="0" :src="store.storeLogo || store.idImg" :alt="store.storeName" />
						</span>
					</router-link>
				</dd>
				<!-- <dd class="shopkeeper">
					店主：{{store.memberName}}
				</dd> -->
			</dl>
			<dl class="w200">
				<dd>商品数量{{store.goodsNum}}件</dd>
				<!-- 李晟超 2016/11/6 修改这里为总成交笔数 -->
				<dd>总成交{{store.buyNum}}笔</dd>
				<dd v-if="store.goodsList.length>0"  class="more-on" v-more-on-off><span>收起相关商品</span><i></i></dd>
			</dl>
          	<dl class="w150">
  				<!-- 店铺信用度 -->
    			<dd>店铺好评率：{{store.praiseRate*100}}%</dd>
    			<dd class="shop-rate" nc_type="shop-rate" store_id="2">
    				店铺动态评分：<span><i></i></span>
    				<div class="shop-rate-con">
          				<div class="arrow"></div>
          				<dl class="rate">
          					<dt>描述相符：</dt>
							<dd class="rate-star">
								<em>
									<i :style="{width:store.storeDesccredit*20+'%'}"></i>
								</em>
								<span>{{store.storeDesccredit?store.storeDesccredit:'5'}}分</span>
							</dd>
							<dt>服务态度：</dt>
              				<dd class="rate-star">
								<em>
									<i :style="{width:store.storeServicecredit*20+'%'}"></i>
								</em>
								<span>{{store.storeServicecredit?store.storeServicecredit:'5'}}分</span>
							</dd>
              				<dt>发货速度：</dt>
              				<dd class="rate-star">
								<em>
									<i :style="{width:store.storeDeliverycredit*20+'%'}"></i>
								</em>
								<span>{{store.storeDeliverycredit?store.storeDeliverycredit:'5'}}分</span>
						</dd>
              			</dl>
              		</div>
				</dd>
			</dl>
			<dl class="w120">
        		<dd class="tr">{{store.storeProvince}}&nbsp;{{store.storeCity}}&nbsp;{{store.storeRegion}}</dd>
      		</dl>
      		<div class="shop-goodslist" v-if="store.goodsList.length>0">
      			<div class="arrow"></div>
      			<div class=" jcarousel-skin-tango">,
      				<div class="jcarousel-container jcarousel-container-horizontal" style="position: relative; display: block;">
      					<div class="jcarousel-clip jcarousel-clip-horizontal" style="position: relative;">
		      				<ul class="jcarousel-list jcarousel-list-horizontal" nc_type="jcarousel" style="overflow: hidden; position: relative; top: 0px; margin: 0px; padding: 0px; left: 0px; width: 1600px;">
		      					<li
		      						class="jcarousel-item jcarousel-item-horizontal jcarousel-item-1 jcarousel-item-1-horizontal"
		      						jcarouselindex="1"
		      						style="float: left; list-style: none; width: 190px;"
		      						v-for="(sgl,index2) in store.goodsList"
		      						>
		            				<dl>
		            					<dt class="goods-pic">
		            						<span class="thumb size160">
		            							<i></i>
		            							<router-link :to="{path:'/goods',query:{goods_id:sgl.goodsId}}" target="_blank">
		            								<img :src="sgl.thumbnail" :alt="sgl.name" width="160" height="160">
		            							</router-link>
		            						</span>
		            					</dt>
		            					<dd class="goods-name">
		            						<router-link :to="{path:'/goods',query:{goods_id:sgl.goodsId}}" :title="sgl.name" target="_blank">
		            							{{sgl.name}}
		            						</router-link>
		            					</dd>
		            					<dd class="goods-price">
		            						<em>&yen;{{sgl.price}}</em>
		            					</dd>
		              					<dd class="goods-sales"><!-- 这里显示最近成交数量 --></dd>
		              				</dl>
		              			</li>
		              		</ul>
              			</div>
					</div>
				</div>
			</div>
		</li>
	</ul>
	</div>
</template>
<script>
export default {
	props:["data"],
	directives:{
		moreOnOff:{
			inserted:function(el){
				$(el).bind("click",function(){
					let li = $(this).parents('li');
					console.log(li);
					if($(this).hasClass('more-on')){
						$(this).removeClass('more-on').addClass('more-off').find('span').text("展开相关商品");
						li.find(".shop-goodslist").hide();
					}else{
						$(this).removeClass('more-off').addClass('more-on').find('span').text("收起相关商品");
						li.find(".shop-goodslist").show();
					}
				});
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// module-shopList.vue?c6c14ec0